import React, { useEffect, useState } from 'react';
import { Checkbox } from '~/components';
import {
  AllocationFiltersGroup,
  ClientFiltersGroup,
  MemberFiltersGroup,
  ProjectFiltersGroup,
  ResourceFiltersGroup,
} from '~/components/filters';
import FiltersDrawer from '../../components/FiltersDrawer';

export default function Filters({ values, isOpen, onClose, onApply }) {
  const [filters, setFilters] = useState(values);

  const handleApply = () => {
    onApply(filters);
  };

  const handleFilter = (filter) => {
    setFilters({ ...filters, ...filter });
  };

  const handleCancel = () => {
    setFilters(values);
    onClose();
  };

  useEffect(() => {
    setFilters(values);
  }, [values]);

  return (
    <FiltersDrawer isOpen={isOpen} onApply={handleApply} onClose={handleCancel}>
      <Checkbox
        checked={filters.onlyAllocatedProjects}
        label="Only show projects with allocations"
        onChange={({ target: { checked } }) => handleFilter({ onlyAllocatedProjects: checked })}
      />

      <ClientFiltersGroup filters={filters} onChange={handleFilter} />

      <ProjectFiltersGroup filters={filters} onChange={handleFilter} />

      <MemberFiltersGroup filters={filters} onChange={handleFilter} />

      <ResourceFiltersGroup filters={filters} onChange={handleFilter} />

      <AllocationFiltersGroup filters={filters} onChange={handleFilter} />
    </FiltersDrawer>
  );
}
